import React, { useState } from 'react';
import { api } from '../utils/api';

export default function WipeModal({ onClose, onComplete }) {
  const [mode, setMode] = useState('all');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [wiping, setWiping] = useState(false);

  const handleWipe = async () => {
    if (!password) { setError('Enter admin password.'); return; }
    setWiping(true);
    setError('');
    try {
      await api.wipeData(password, mode);
      if (mode === 'all') { window.location.reload(); }
      else { onComplete(mode); onClose(); }
    } catch (err) {
      setError(err.message);
    }
    setWiping(false);
  };

  const modes = [
    { val: 'all', label: 'Everything', desc: 'Nuclear reset — empty system' },
    { val: 'confs', label: 'Confirmations only', desc: 'Keep data & users, reset all YES/NO' },
    { val: 'data', label: 'Godown data + confirmations', desc: 'Keep users & cut-offs' },
    { val: 'users', label: 'Users only', desc: 'Keep godown data (admin preserved)' },
  ];

  return (
    <div className="overlay" onClick={e => e.target.className === 'overlay' && onClose()}>
      <div className="modal" style={{ maxWidth: 440, textAlign: 'center' }}>
        <div style={{ fontSize: 48 }}>⚠️</div>
        <h3 className="text-red">DATA WIPE</h3>
        <p className="text-sm text-muted">This will permanently delete data. Cannot be undone. Export a backup first.</p>

        <div className="wipe-options">
          {modes.map(m => (
            <label key={m.val} className="wipe-option">
              <input type="radio" name="wipe-mode" value={m.val}
                checked={mode === m.val} onChange={() => setMode(m.val)} />
              <strong>{m.label}</strong> — {m.desc}
            </label>
          ))}
        </div>

        <div className="field" style={{ textAlign: 'left' }}>
          <label className="text-red">🔒 Enter Admin Password to Confirm</label>
          <input type="password" value={password} onChange={e => setPassword(e.target.value)}
            placeholder="Admin password required" style={{ textAlign: 'center' }} />
        </div>

        {error && <div className="error-msg">{error}</div>}

        <div className="modal-act-center">
          <button className="btn btn-o" onClick={onClose}>Cancel</button>
          <button className="btn btn-danger" onClick={handleWipe} disabled={wiping}>
            {wiping ? 'Wiping...' : '🗑 Wipe Data'}
          </button>
        </div>
        <p className="text-xs text-muted" style={{ marginTop: 10, fontStyle: 'italic' }}>⚙ This feature can be disabled in production.</p>
      </div>
    </div>
  );
}
